import { useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router";
import { toast } from "react-toastify";
import {
  clearVisualizacion,
  getFormulariosPrevencionEstablecimiento,
  postFormularioRarFirmado,
  postFormularioRgrlFirmado,
  visualizarCertificadoPresentacion,
  visualizarFormularioPresentado,
} from "../../../../redux/actions/establecimiento";
import BackArrowHeader from "../../../commons/arrow/BackArrowHeader";
import { StyledEstablecimientos } from "../../../styled/Prevencion";
import EstadoEstablecimientoDetalle from "./DetalleEstablecimiento";
import DialogAdjuntarFormulario from "./dialogs/DialogAdjuntarFormulario";
import ViewDialog from "./dialogs/ViewDialog";

const EstadoEstablecimientoContainer = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { state } = useLocation();

  const visualizacion = useSelector((state) => state.establecimiento.viewFile?.base64);

  const [isModalAdjuntarFormOpen, setIsModalAdjuntarFormOpen] = useState(false);
  const [viewDialogTitle, setViewDialogTitle] = useState("");
  const [isAdjuntandoFormulario, setIsAdjuntandoFormulario] = useState(false);
  const [isModalViewOpen, setIsModalViewOpen] = useState(false);
  const [formularioFirmadoAdjunto, setFormularioFirmadoAdjunto] = useState(null);
  const formularioSeleccionadoAdjuntar = useRef(null);

  const handleEditarResolucion81 = (idFormulario) => {
    navigate("/prevencion/resolucion-81/form", {
      state: {
        idFormulario,
        idDependenciaEmpleador: state?.idDependenciaEmpleador,
      }
    });
  };

  const handleAdjuntarFormularioFirmado = (file) => {
    setIsAdjuntandoFormulario(true);
    if (formularioSeleccionadoAdjuntar.current?.codigoArtFormulario === 3) {
      dispatch(postFormularioRgrlFirmado(file, formularioSeleccionadoAdjuntar.current))
        .then((res) => {
          toast.success("El formulario fue cargado con éxito");
          setIsAdjuntandoFormulario(false);
          setIsModalAdjuntarFormOpen(false);
          // el clear es necesario para que el Dropzone no se abra
          // con un formulario viejo (de algun render anterior)
          setFormularioFirmadoAdjunto(null);
          // tambien tenemos que hacer un getFormulariosPrevencion de nuevo,
          // ya que el estado del formulario al cual se le adjunta el pdf
          // firmado, va a cambiar de pre-presentado -> revision.
          dispatch(getFormulariosPrevencionEstablecimiento(state?.idDependenciaEmpleador));
        })
        .catch((err) => {
          toast.error(err);
          setIsAdjuntandoFormulario(false);
          setIsModalAdjuntarFormOpen(true);
          // el clear es necesario para que el Dropzone no se abra
          // con un formulario viejo (de algun render anterior)
          setFormularioFirmadoAdjunto(null);
        });
    } else if (
      formularioSeleccionadoAdjuntar.current?.codigoArtFormulario === 11
    ) {
      dispatch(
        postFormularioRarFirmado(file, formularioSeleccionadoAdjuntar.current)
      )
        .then((res) => {
          toast.success("El formulario fue cargado con éxito");
          setIsAdjuntandoFormulario(false);
          setIsModalAdjuntarFormOpen(false);
          // el clear es necesario para que el Dropzone no se abra
          // con un formulario viejo (de algun render anterior)
          setFormularioFirmadoAdjunto(null);
          // tambien tenemos que hacer un getFormulariosPrevencion de nuevo,
          // ya que el estado del formulario al cual se le adjunta el pdf
          // firmado, va a cambiar de pre-presentado -> revision.
          dispatch(
            getFormulariosPrevencionEstablecimiento(
              state?.idDependenciaEmpleador
            )
          );
        })
        .catch((err) => {
          toast.error(err);
          setIsAdjuntandoFormulario(false);
          setIsModalAdjuntarFormOpen(true);
          // el clear es necesario para que el Dropzone no se abra
          // con un formulario viejo (de algun render anterior)
          setFormularioFirmadoAdjunto(null);
        });
    }
  };

  const handleVisualizar = (formulario, title) => {
    setViewDialogTitle(title);
    setIsModalViewOpen(true);
    if (title === "Certificado de presentación") {
      dispatch(
        visualizarCertificadoPresentacion(
          formulario?.idFormularioProgramaPrevencionEmpleador
        )
      );
    } else {
      dispatch(
        visualizarFormularioPresentado(
          formulario?.idFormularioProgramaPrevencionEmpleador,
          formulario?.codigoArtFormulario
        )
      );
    }
  };

  return (
    <StyledEstablecimientos.PaperContainer>
      <div style={{ display: "flex", justifyContent: "flex-start" }}>
        <BackArrowHeader
          onClick={() => navigate("/prevencion/establecimientos")}
        />
      </div>
      <StyledEstablecimientos.ContentContainer>
        <EstadoEstablecimientoDetalle
          establecimiento={state}
          formularioSeleccionadoAdjuntar={formularioSeleccionadoAdjuntar}
          setIsModalAdjuntarFormOpen={setIsModalAdjuntarFormOpen}
          handleVisualizar={handleVisualizar}
          handleEditarResolucion81={handleEditarResolucion81}
        />
      </StyledEstablecimientos.ContentContainer>
      <DialogAdjuntarFormulario
        open={isModalAdjuntarFormOpen}
        onClose={() => {
          setIsModalAdjuntarFormOpen(false);
        }}
        title="Adjuntar formulario firmado"
        file={formularioFirmadoAdjunto}
        setFile={setFormularioFirmadoAdjunto}
        isAdjuntando={isAdjuntandoFormulario}
        handleCancelClick={() => {
          setFormularioFirmadoAdjunto(null);
          setIsModalAdjuntarFormOpen(false);
        }}
        handleConfirmClick={() => {
          handleAdjuntarFormularioFirmado(formularioFirmadoAdjunto[0]);
        }}
        isConfirmButtonDisabled={
          !formularioFirmadoAdjunto || formularioFirmadoAdjunto?.length <= 0
        }
      />
      <ViewDialog
        open={isModalViewOpen}
        title={viewDialogTitle}
        file={visualizacion}
        onClose={() => {
          // el clear es necesario para que el PdfDialog no se abra
          // con un formulario viejo (de algun render anterior)
          dispatch(clearVisualizacion());
          setIsModalViewOpen(false);
        }}
      />
    </StyledEstablecimientos.PaperContainer>
  );
};

export default EstadoEstablecimientoContainer;
